import { useEffect, useRef } from 'react';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';

import styles from './embed.module.scss';

export default function Embed(props) {
    const { data, className, estil } = props;
    const htmlRoot = useRef();

    const styleEmbed = clsx({
        [styles.richtext]: true,
        [styles[estil]]: !__isEmpty(estil),
        [className]: !__isEmpty(className)
    });

    useEffect(() => {
        htmlRoot.current.innerHTML = '';
        const range = document.createRange();
        const documentFragment = range.createContextualFragment(data);
        htmlRoot.current.append(documentFragment);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    return <div className={styleEmbed} ref={htmlRoot} />;
}
